import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import PropTypes from "prop-types";
import { Route, Switch, Redirect } from "react-router-dom";
import { isWithinInterval } from "date-fns";
import makeStringMatcher from "src/lib/make-string-matcher";
import { setOffer } from "src/redux/gifts/actions";
import NotFound from "src/react/pages/not-found";
import GiftsProducts from "./products";
import GiftsBasket from "./basket";
import GiftsCheckout from "./checkout";

export const isBlackFriday = isWithinInterval(new Date(), {
  start: new Date("2025-11-23"),
  end: new Date("2025-12-15"),
});

function GiftsRoutes({ isUserAccountActive, match }) {
  const dispatch = useDispatch();
  const matches = makeStringMatcher(match.path);
  const isGiftOffer = matches("^/gifts-offers") || matches("^/vodafone20");

  useEffect(() => {
    dispatch(setOffer({ isGiftOffer: isBlackFriday || isGiftOffer }));
  }, [dispatch, isGiftOffer]);

  if (isUserAccountActive && !isGiftOffer) {
    return <Redirect to="/account/topup" />;
  }

  return (
    <Switch>
      <Route exact path={`${match.path}/basket`} component={GiftsBasket} />
      <Route exact path={`${match.path}/checkout`} component={GiftsCheckout} />
      <Route exact path={match.path} component={GiftsProducts} />
      <Route component={NotFound} />
    </Switch>
  );
}

GiftsRoutes.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }).isRequired,
  isUserAccountActive: PropTypes.bool,
};

export default GiftsRoutes;
